<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconPrompt',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9,0 C4.02991071,0 0,4.02991071 0,9 C0,13.9700893 4.02991071,18 9,18 C13.9700893,18 18,13.9700893 18,9 C18,4.02991071 13.9700893,0 9,0 Z M10.6875,6.89263393 L8.93973214,12.9475446 C8.84330357,13.2930804 8.79508929,13.5220982 8.79508929,13.6285714 C8.79508929,13.6908482 8.82120536,13.7491071 8.87142857,13.8033482 C8.92165179,13.8575893 8.97589286,13.8837054 9.03415179,13.8837054 C9.13058036,13.8837054 9.22700893,13.8415179 9.3234375,13.7551339 C9.57857143,13.5441964 9.8859375,13.1645089 10.2435268,12.6140625 L10.5328125,12.7848214 C9.675,14.2794643 8.76495536,15.0267857 7.79866071,15.0267857 C7.42901786,15.0267857 7.13571429,14.9223214 6.91674107,14.7154018 C6.69776786,14.5084821 6.58928571,14.2453125 6.58928571,13.9279018 C6.58928571,13.7169643 6.6375,13.4517857 6.73392857,13.1263393 L7.9171875,9.05424107 C8.03169643,8.6625 8.08794643,8.3671875 8.08794643,8.16830357 C8.08794643,8.04375 8.03370536,7.93325893 7.92522321,7.83683036 C7.81674107,7.74040179 7.67008929,7.6921875 7.48325893,7.6921875 C7.39888393,7.6921875 7.29642857,7.69419643 7.17589286,7.70022321 L7.28638393,7.35870536 L10.1732143,6.890625 L10.6875,6.890625 L10.6875,6.89263393 Z M11.0450893,5.11071429 C10.8,5.35580357 10.5046875,5.47633929 10.1591518,5.47633929 C9.81763393,5.47633929 9.52633929,5.35379464 9.28125,5.11071429 C9.03616071,4.865625 8.915625,4.5703125 8.915625,4.22477679 C8.915625,3.87924107 9.03616071,3.58392857 9.27723214,3.33883929 C9.51830357,3.09575893 9.81160714,2.97321429 10.1591518,2.97321429 C10.5107143,2.97321429 10.8080357,3.09575893 11.0491071,3.33883929 C11.2901786,3.58392857 11.4107143,3.87924107 11.4107143,4.22477679 C11.4107143,4.5703125 11.2881696,4.865625 11.0450893,5.11071429 L11.0450893,5.11071429 Z"
      ></path>
    </svg>
  </i>
</template>
